import React from 'react';
import PropTypes from 'prop-types';
import {Modal} from 'react-bootstrap';
import {connect} from 'react-redux';
import moment from 'moment';
import {hidePurchaseMap, purchaseMap, showAddCard, getMap, downloadMap, notify } from 'actions';

class PurchaseMap extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'PurchaseMap';
        this.purchaseMap = this.purchaseMap.bind(this);
        this.cancel = this.cancel.bind(this);
    }
    cancel() {
    	this.props.dispatch(hidePurchaseMap());
    }
    purchaseMap() {

        var purchaseAction = purchaseMap({...this.props.maps.purchaseMap, features : []}, (error, charge) => {

            if(error) {
              console.log('ERROR IN purchaseMap : ', error)
              this.props.dispatch(notify({message : error.message || error}));

              if(error && error.message == 'Cannot charge a customer that has no active card') {
                this.props.dispatch(showAddCard());
              }
            }
            else {
              this.props.dispatch(notify({title : 'Success!', message : 'Map Purchased'}, {type : 'success'}));
              this.props.dispatch(downloadMap(this.props.maps.purchaseMap._id, () => this.props.dispatch(hidePurchaseMap())));
            }
        })
        this.props.dispatch(purchaseAction);
    }
    render() {

    	if(this.props.maps.showPurchaseMap && this.props.maps.purchaseMap) {
    		var map = this.props.maps.purchaseMap;

        return (
        	<div>
        	<Modal show={this.props.maps.showPurchaseMap} onHide={this.cancel}>
        		<div className="panel panel-primary mb-none">
        			<div className="panel-heading mb-none">
        				<h3 className="panel-title"><i className="fa fa-shopping-basket"></i>Buy Individual Map</h3>
        			</div>

						<div className="row">

							<div className="pricing-table mt-none mb-none">
								<div className="col-xs-12">
									<div className="plan mb-none">
										<h3><i>{"Map - " + map.properties.title}</i><span>{"$" +(Number(map.properties.price) / 100).toFixed(2)}</span></h3>
										<div className="impact-details">
											<ul>
				        					{(()=>{
				        						if(map.properties.cities.length > 0)
				        							return <li>Cities: {map.properties.cities.join(',')}</li>
				        					})()}
				        					   <li>{map.properties.description}</li>
					        					<li><h4> States Affected: {map.properties.states.join(',')}</h4></li>
					        					<li><h4> {map.properties.star_level} Star</h4></li>
					        					<li><span className="impact-details-icon"><span className="fa fa-calendar"></span></span><span className="impact-details-info"> {moment(map.properties.storm_date).format('MMM DD, YYYY')}</span></li>
					        					<li><span className="impact-details-icon"><span className="fa fa-home"></span></span><span className="impact-details-info">  {map.properties.max_house_count}</span></li>
					        					<li><span className="impact-details-icon"><span className="fa fa-certificate"></span></span><span className="impact-details-info"> {map.properties.max_hail_size}{'"'}</span></li>
					        					<li><span className="impact-details-icon impact-details-icon-windy"><span className="wi wi-windy"></span></span><span className="impact-details-info">{map.properties.max_wind_speed_direction} {map.properties.max_wind_speed} mph</span></li>
				        					</ul>
				    					</div>
				    				</div>
								</div>
							</div>
						</div>


        			<div className="panel-footer">
        				<div className="row">
        					<div className="col-xs-6 col-md-4 col-md-offset-4">
        						<div onClick={this.cancel} className="btn btn-block btn-default">Cancel</div>
        					</div>
        					<div className="col-xs-6 col-md-4">
        						<div onClick={this.purchaseMap} className="btn btn-block btn-success"><i className="fa fa-money"></i> Buy Now</div>
        					</div>
        				</div>
        			</div>
        		</div>
        	</Modal>
        	</div>
        );
          }

   		else
   			return <div></div>
    }
}

var mapStateToProps = ({maps}) => {
	return {maps};
}

export default connect(mapStateToProps)(PurchaseMap);



// WEBPACK FOOTER //
// ./src/browser/components/account/purchaseMap.js